import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContainerComponent } from '../../../shared/components/container/container.component';
import { PictureComponent } from '../../../shared/components/picture/picture.component';
import { GlobalButtonComponent } from '../../../shared/components/global-button/global-button.component';

@Component({
  selector: '[section4]',
  imports: [
    ContainerComponent,
    PictureComponent,
    GlobalButtonComponent
  ],
  templateUrl: './section4.component.html',
  styleUrl: './section4.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Section4Component { }
